<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 549.6 549.6"
    class="icon-pin-circle"
  >
    <g id="button">
      <circle id="shadow" class="cls-1" cx="274.8" cy="274.8" r="274.8" />
      <circle
        id="background-ring-white"
        class="cls-2"
        cx="274.8"
        cy="274.8"
        r="253.02"
      />
      <circle
        id="background-ring-color"
        class="cls-3"
        :style="{
          stroke: color
        }"
        cx="274.8"
        cy="274.8"
        r="231.79"
      />
      <circle
        id="background-color"
        :style="{
          fill: color
        }"
        cx="274.8"
        cy="274.8"
        r="190.05"
      />
      <g id="pin_icon" data-name="pin icon">
        <path
          class="cls-5"
          d="M364.63,234.72c-16,18.25-31.82,36.49-47.79,54.63-3.8,4.24-4.89,7.71-1.85,13.58,5.87,11.19,4.46,22.48-3.36,32.69-3.91,4.89-8.15,6-13,1Q252.33,290.17,205.83,244c-5.54-5.54-3.91-10,1.31-14,9.77-7.5,21-9.23,31.5-3.15,6.51,3.8,10,1.85,14.55-2.17,16.29-14.23,33-27.92,49-42.58,6.73-6.19,10.75-5.54,16.51,1,13.58,15.42,27.26,30.84,43.23,44C365,228.85,367.35,230.92,364.63,234.72Z"
        />
        <path
          class="cls-5"
          d="M248.41,312.71c-26.07,27.15-54,51.91-88.09,69.84a248.66,248.66,0,0,1,36.17-50.62c11.08-12.16,23.25-23.24,34.54-35.3,4.67-5,8.69-6,11.84.33C245.48,301.84,257.75,303,248.41,312.71Z"
        />
        <path
          class="cls-5"
          d="M400.15,219.29c-3.48,5.87-9.77,8.26-16.83,8-6.2.65-10.65-2.5-14.78-6.62q-23.46-23.62-46.92-47c-4.78-4.78-8-10-6.95-17.27.87-6.3,3.15-12.06,9-14.67,6.2-2.71,9.24,3.26,12.82,6.74q28.68,28.35,57,57C397.22,209.3,404,212.67,400.15,219.29Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import { Pinning } from "@/utils/Pinning";

export default {
  name: "IconPinCircle",
  mixins: [Pinning],
  props: {
    colorLabel: {
      type: String,
      required: false
    }
  },
  computed: {
    color() {
      return this.getPinPickerColor(this.colorLabel);
    }
  }
};
</script>

<style scoped>
.cls-1 {
  fill: #cacaca;
}
.cls-2,
.cls-3,
.cls-5 {
  fill: #fff;
}
.cls-3 {
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 21.53px;
}

.cls-5 {
  stroke: #fff;
  stroke-miterlimit: 10;
}

.icon-pin-circle {
  border-width: 1px;
  border-radius: 50%;
}
</style>
